import { CommonModule, registerLocaleData } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import localeNl from '@angular/common/locales/nl';

import { ApLoggingModule } from '@ap/logging';

import { ApWebcontainerDarkmodeService } from './darkmode/webcontainer-darkmode.service';

registerLocaleData(localeNl, 'nl');

@NgModule({
    imports: [CommonModule, ApLoggingModule],
    providers: [ApWebcontainerDarkmodeService]
})
export class ApWebContainerModule {
    constructor() {
        const webcontainerDarkmodeService = inject(ApWebcontainerDarkmodeService);

        webcontainerDarkmodeService.initDarkmode();
    }
}
